module.exports = __webpack_public_path__ + "img/BINDI 3 GREEN.d04fdc5.svg";